import { render, staticRenderFns } from "./EditProjectCompanyComponent.vue?vue&type=template&id=0ec0f8da&scoped=true&"
import script from "./EditProjectCompanyComponent.vue?vue&type=script&lang=js&"
export * from "./EditProjectCompanyComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditProjectCompanyComponent.vue?vue&type=style&index=0&id=0ec0f8da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec0f8da",
  null
  
)

export default component.exports